export enum SolarModuleType {
  PV = 'PV',
  CSP = 'CSP',
  MONOCRYSTALLINE = 'MONOCRYSTALLINE',
  POLYCRYSTALLINE = 'POLYCRYSTALLINE',
  THIN_FILM = 'THIN_FILM',
  OTHER = "OTHER",
}
export const solarModuleTypeToLabel = {
  [SolarModuleType.PV]: 'PV',
  [SolarModuleType.CSP]: 'CSP',
  [SolarModuleType.MONOCRYSTALLINE]: 'Monocrystalline',
  [SolarModuleType.POLYCRYSTALLINE]: 'Polycrystalline',
  [SolarModuleType.THIN_FILM]: 'Thin film',
  [SolarModuleType.OTHER]: 'Other',
};
